
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { LanguageSuggestionComponent } from '../language-suggestion/language-suggestion.component';

@Component({
  selector: 'layout-default',
  imports: [RouterOutlet, FooterComponent, HeaderComponent, LanguageSuggestionComponent],
  templateUrl: './layout.component.html',
})
export class LayoutComponent {}
